export default "__VITE_ASSET__53UwFl0i__"